import { bind, classNames, Component, h, tag } from "omi";

import { NWIcon, NWTooltip } from "@/components";
import { Store } from "@/store";
import { tailwind } from "@/tailwind";

type Props = {
  iconOnly?: boolean;

  /**
   * Used for analytics tracking
   */
  location: string;

  /**
   * Additional data to pass to the analytic event.
   */
  analyticsData?: Record<string, string>;
};

@tag("nw-pro-badge")
export class NWProBadge extends Component<Props> {
  static css = [tailwind];
  static propTypes = {
    iconOnly: Boolean,
  };

  @bind
  private handleOnClick() {
    const isPro = Store.user.isPro() ?? false;
    import("@/services/analyticsService").then(({ useAnalyticsService }) => {
      useAnalyticsService().trackProClicked(isPro, this.props.location, this.props.analyticsData);
    });
  }

  renderBadge({ iconOnly = false }: Props) {
    const theme = Store.user.isPro() ? "dark" : "light";

    return (
      <div className="w-fit" onClick={this.handleOnClick}>
        <div
          id="badge"
          className={classNames(
            "flex gap-1 select-none whitespace-nowrap text-nowrap items-center justify-between rounded-[4px] capitalize px-1 py-0.5",
            {
              "bg-primary text-primary": theme === "light",
              "bg-leather text-white": theme === "dark",
            },
          )}
        >
          <NWIcon name={theme === "dark" ? "logo-mark-light" : "logo-mark-dark"} width={12} height={12} />
          {!iconOnly && <p className="text-xs font-normal">Pro</p>}
        </div>
      </div>
    );
  }

  render(props: Props) {
    if (Store.user.isPro()) {
      return (
        <NWTooltip content="You're a Pro!" strategy="absolute" placement="top">
          {this.renderBadge(props)}
        </NWTooltip>
      );
    }

    return this.renderBadge(props);
  }
}
